import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CmsConfig, ConfigModule, UrlModule} from '@spartacus/core';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CustomCarouselModule} from '../../../../spartacus/custom/shared/components/custom-carousel/custom-carousel.module';
import {MediaModule} from '@spartacus/storefront';
import {RouterModule} from '@angular/router';
import {CustomCategoryCarouselComponent} from './custom-category-carousel.component';


@NgModule({
  declarations: [CustomCategoryCarouselComponent],
  exports: [CustomCategoryCarouselComponent],
  imports: [
    CommonModule, MediaModule, RouterModule, UrlModule,
    CustomCmsItemModule,
    CustomCarouselModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CategoryCarouselComponent: {
          component: CustomCategoryCarouselComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomCategoryCarouselModule { }
